import _ from 'lodash';

const OPTIONS = [
  'doorLock',
  'doorUnlock',
].map(value => ({
  name: _.startCase(value),
  value,
  action: value
}));

/**
 * @typedef Equipment
 * @property {string} id
 * @property {object} [settings]
 * @property {string} [settings.guid]
 */

/* @ngInject */
export default function GenetecService($sails, $q, $log) {
  const vm = this;

  vm.getStatus = getStatus;
  vm.getOptions = () => OPTIONS;
  vm.performAction = performAction;
  vm.processCurrentOption = processCurrentOption;

  /**
   * Gets the status of the panel from the server.
   *
   * @param {Equipment} equipment
   * @returns {Promise<object>} Status
   */
  function getStatus({ id, settings }) {
    return $sails
      .get(`/equipment/${id}/statuses/getStatus?guid=${settings.GUID}`)
      .then(({ data: { status: currentOption } }) => ({ currentOption }))
      .catch(catchError);
  }

  /**
   * @param {Equipment} equipment
   * @param {string} action
   * @returns {Promise<object>} Response
   */
  function performAction(equipment, action) {
    const { id, settings: { guid } = {} } = equipment;
    return $sails.post(`/equipment/${equipment.id}/actions/${action}`, { id, guid })
      .catch(catchError);
  }

  /**
   * Converts event name from Genetec naming convention
   *
   * @param {object} event
   * @param {string} event.EventType
   * @returns {object} Formatted current-option
   */
  function processCurrentOption({ EventType }) {
    return { currentOption: _.camelCase(EventType) };
  }

  /**
   * @param {Error} error
   * @returns {Promise<Error>}
   * @private
   */
  function catchError(error) {
    $log.log('Error: ', error);
    return $q.reject(error.data);
  }
}
